import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon, CaretRightIcon, WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, FormatNumber, Link, Text } from '@reveni-io/reveni-ui'

import SizingIssuesTooltip from '../SizingIssuesTooltip/SizingIssuesTooltip'
import SizingTooltip from '../SizingIssuesTooltip/SizingTooltip/SizingTooltip'
import * as Styles from './styles'

const Product = ({
  product,
  onClick,
  showAmounts = true,
  salesOrdersDataActivated,
  sizeRecommendationsActivated = false,
  isUnifiedDashboard,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container onClick={onClick}>
      <Styles.SideContainer>
        <Text type="bodyMRegular" color={theme.colors.text.subtle} customStyles={{ minWidth: '20px' }}>
          {product?.index}
        </Text>

        <Styles.ProductImage src={product?.product_image_url || '/images/placeholderImg.png'} alt={product?.name} />

        <Styles.LinkAndVariantsContainer>
          <Text type="titleS">{product?.name}</Text>
          {!isUnifiedDashboard && (
            <Link href={product?.product_url} target="_blank" type="bodyMRegular">
              <Text type="linkS">{t('Ver en tienda')}</Text>
              <ArrowSquareOutIcon size={16} />
            </Link>
          )}
          <Text type="bodySRegular">
            <FormatNumber style="decimal">{product?.variant_count}</FormatNumber>{' '}
            {product?.variant_count > 1 ? t('variantes') : t('variante')}
          </Text>
          {sizeRecommendationsActivated && product?.has_size_recommendation && (
            <SizingTooltip
              title={
                <SizingIssuesTooltip
                  recommendation={product?.recommendation}
                  recommendationGlobal={product?.recommendation_global}
                />
              }
            >
              <Styles.ChipWrapper>
                <Chip
                  label={t('Problemas de talla')}
                  Icon={WarningIcon}
                  backgroundColor={theme.colors.warning.surface}
                  color={theme.colors.warning.onSurface}
                />
              </Styles.ChipWrapper>
            </SizingTooltip>
          )}
        </Styles.LinkAndVariantsContainer>
      </Styles.SideContainer>
      {showAmounts && (
        <Styles.SideContainer>
          {salesOrdersDataActivated && (
            <Styles.Total type="bodyMRegular">
              <FormatNumber style="decimal">{product?.sales}</FormatNumber>
            </Styles.Total>
          )}
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="decimal">{product?.count}</FormatNumber>
          </Styles.Total>
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="percent">{product?.percentage}</FormatNumber>
          </Styles.Total>
          <Styles.NavigationContainer>
            {typeof onClick === 'function' && <CaretRightIcon size={24} />}
          </Styles.NavigationContainer>
        </Styles.SideContainer>
      )}
    </Styles.Container>
  )
}

export default Product
